<script>
  import { pagingStore, showNext, showPrev } from "../stores/paging.js";
  import { stylesColor } from "../stores/styles.js";
</script>

<style>
  button {
    @apply fixed;

    top: 50%;

    @apply p-10;

    color: var(--color);
    @apply rounded-full;
    @apply bg-gray-200;
    @apply opacity-100;
    background: rgba(0, 0, 0, 0.2);

    @apply ease-in-out;
    @apply duration-500;
    @apply transition-all;
  }
  button.hide {
    @apply opacity-0;
  }
  button.prev {
    @apply left-0;
    @apply ml-5;
  }
  button.next {
    @apply right-0;
    @apply mr-5;
  }
</style>

<button
  class="prev"
  on:click={pagingStore.prev}
  class:hide={!$showPrev}
  style="--color:{$stylesColor}">
  Prev
</button>
<button
  class="next"
  on:click={pagingStore.next}
  class:hide={!$showNext}
  style="--color:{$stylesColor}">
  Next
</button>
